export default __webpack_public_path__ + "static/media/unionpay-single.fd0d4860.svg";